import conf from '../config/api.js';
import Vue from 'vue';
import script from './script.js'
import vuexStorage from '../store/index.js'
var moment = require('moment');
var htmlDecode = require('js-htmlencode').htmlDecode;

//Fonction génération de toaster erreur
function toasterError(content, title){
    new Vue().$notify({
        title: title,
        message: content,
        type: 'error',
        position: 'bottom-right'
    })
}

//Fonction génération de toaster réussite
function toasterSuccess(content, title){
    new Vue().$notify({
        title: title,
        message: content,
        type: 'success',
        position: 'bottom-right'
    })
}

//Fonction pour trouver la Géoloc des clients
async function getGeoloc(lat,long,radius,section_activite_principale){
    try {
        let response = await requestApi({
            method: 'GET',
            url: '/api/getGeoloc',
            form: {},
            params: {lat: lat, long: long, radius: radius, section_activite_principale: section_activite_principale},
            headers: { 'Content-Type': 'application/json' }
        });
        return response
    } catch {
        toasterError(`Une erreur interne est survenue`,'Erreur interne')
    }
}

//Fonction pour récupérer la liste des prospections
async function getProspectionList(){
    try {
        let response = await requestApi({
            method: 'GET',
            url: '/api/getProspectionList',
            form: {},
            params: {},
            headers: { 'Content-Type': 'application/json' }
        });
        return response
    } catch {
        toasterError(`Une erreur interne est survenue`,'Erreur interne')
    }
}

//Fonction pour créer une liste de prospection
async function createProspectionList(name, return_to_start, start_to_pos){
    try {
        let response = await requestApi({
            method: 'POST',
            url: '/api/createProspectionList',
            form: {name: name, return_to_start: return_to_start, start_to_pos: start_to_pos},
            params: {},
            headers: { 'Content-Type': 'application/json' }
        });
        return response
    } catch {
        toasterError(`Une erreur interne est survenue`,'Erreur interne')
    }
}

//Fonction pour supprimer une liste de prospection
async function deleteProspectionList(rowid){
    try {
        let response = await requestApi({
            method: 'DELETE',
            url: '/api/deleteProspectionList',
            form: {rowid: rowid},
            params: {},
            headers: { 'Content-Type': 'application/json' }
        });
        return response
    } catch {
        toasterError(`Une erreur interne est survenue`,'Erreur interne')
    }
}

//Fonction pour modifier une liste de prospection
async function updateProspectionList(rowid, name, return_to_start, start_to_pos){
    try {
        let response = await requestApi({
            method: 'PUT',
            url: '/api/updateProspectionList',
            form: {rowid: rowid, name: name, return_to_start: return_to_start, start_to_pos: start_to_pos},
            params: {},
            headers: { 'Content-Type': 'application/json' }
        });
        return response
    } catch {
        toasterError(`Une erreur interne est survenue`,'Erreur interne')
    }
}

//Fonction pour ajouter un client à une liste de prospection
async function addToProspectionList(listId, thirdpartyName, thirdpartyAddress, latitude, longitude, orderList){
    try {
        let response = await requestApi({
            method: 'POST',
            url: '/api/addToProspectionList',
            form: {listId: listId, thirdpartyName: thirdpartyName, thirdpartyAddress: thirdpartyAddress, latitude: latitude, longitude: longitude, orderList: orderList},
            params: {},
            headers: { 'Content-Type': 'application/json' }
        });
        return response
    } catch {
        toasterError(`Une erreur interne est survenue`,'Erreur interne')
    }
}

//Fonction pour supprimer un client d'une liste de prospection
async function deleteToProspectionList(listId, rowid){
    try {
        let response = await requestApi({
            method: 'DELETE',
            url: '/api/deleteToProspectionList',
            form: {listId: listId, rowid: rowid},
            params: {},
            headers: { 'Content-Type': 'application/json' }
        });
        return response
    } catch {
        toasterError(`Une erreur interne est survenue`,'Erreur interne')
    }
}

//Fonction pour modifier un client d'une liste de prospection
async function updateToProspectionList(listId, rowid, orderList){
    try {
        let response = await requestApi({
            method: 'PUT',
            url: '/api/updateToProspectionList',
            form: {listId: listId, rowid: rowid, orderList: orderList},
            params: {},
            headers: { 'Content-Type': 'application/json' }
        });
        return response
    } catch {
        toasterError(`Une erreur interne est survenue`,'Erreur interne')
    }
}

//Fonction pour récupérer les détails d'une liste de prospection
async function getProspectionListDet(listId){
    try {
        let response = await requestApi({
            method: 'GET',
            url: '/api/getProspectionListDet',
            form: {},
            params: {listId: listId},
            headers: { 'Content-Type': 'application/json' }
        });
        return response
    } catch {
        toasterError(`Une erreur interne est survenue`,'Erreur interne')
    }
}

// Fonction appel api
/*
  args: options : method -- required
                  url -- required
                  params -- optional -- url parameters
                  form -- optional -- request body applicable only with PUT, POST and Patch methods
                  headers -- optional
*/
function requestApi (options) {
    return new Promise((resolve, reject) => {
        new Vue().axios({
            method: options.method,
            url: conf.server + options.url,
            params: options.params,
            data: options.form,
            headers: options.headers,
            withCredentials: true
        }).then((response) => {
            resolve(response.data)
        }).catch((error) => {
            reject(error)
        })
    })
}

export default {
    toasterError,
    toasterSuccess,
    getGeoloc,
    createProspectionList,
    deleteProspectionList,
    updateProspectionList,
    getProspectionList,
    addToProspectionList,
    deleteToProspectionList,
    updateToProspectionList,
    getProspectionListDet
}
